import { createConsumer } from '@rails/actioncable';
import React, { useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { downloadBlob } from '../../helpers/downloadBlob';

// Used as interfacing component for Sidekiq Exports Jobs
// Handles: Submission Exports & Global Search Result Exports
const ExportConsumer = ({ uuid, filename, exportName }) => {
  const cable = useRef();
  const [status, setStatus] = useState('Connecting to Server, please wait...');
  const [numberChunks, setNumberChunks] = useState(0);
  const [header, setHeader] = useState('');
  const [chunks, setChunks] = useState([]);
  const [errors, setErrors] = useState('');
  const progressStatuses = ['Connected', 'Exporting...'];
  const location = useLocation();
  const nav = useNavigate();
  const globalExport = location.pathname == '/manage/containers/export_result';

  const downloadCSV = () => {
    let csvData = chunks
      .filter((chunk) => chunk[1].length)
      .sort((a, b) => a[0] - b[0])
      .map((chunk) => chunk[1]);
    let blob = new Blob([header + csvData.join('')], { type: 'octet/stream' });
    downloadBlob(blob, filename);
  };

  useEffect(() => {
    if (
      status === 'Complete' &&
      chunks.length === numberChunks &&
      chunks.length > 0
    ) {
      setErrors('');
      downloadCSV();
      if (cable.current) cable.current.disconnect();
    }
    const handleBeforeUnload = (event) => {
      if (cable.current?.subscriptions?.subscriptions?.length)
        cable.current?.subscriptions?.subscriptions.forEach((subscription) => {
          subscription.cancelJob(status);
        });
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [status, chunks.length]);

  useEffect(() => {
    if (!cable.current) cable.current = createConsumer();

    const channel = {
      channel: 'ExportChannel',
      export_id: uuid,
    };

    const handlers = {
      received(data) {
        console.log(data);
        if (data.status) setStatus(data.status);
        if (data.number_chunks) setNumberChunks(data.number_chunks);
        if (data.csv_header) setHeader(data.csv_header);
        if (data.chunk_complete)
          setChunks((chunks) => [...chunks, data.chunk_complete]);
        if (data.error) setErrors(data.error);
      },
      connected() {
        console.log('ws connected', channel);
      },
      disconnected() {
        console.log('ws disconnected');
        cable.current = null;
      },
      cancelJob(status) {
        if (status != 'Complete') {
          this.perform('cancel_job', { uuid, status });
        }
      },
    };

    cable.current.subscriptions.create(channel, handlers);

    return () => {
      if (cable.current) cable.current.disconnect();
    };
  }, []);

  return (
    <section>
      <div className='container'>
        {globalExport ? (
          <h2>Exporting Global Search Results - {exportName}</h2>
        ) : (
          <h2>Exporting - {exportName}</h2>
        )}
        <div className='details' style={{ marginTop: '16px' }}>
          <div className='row'>
            <div className='name'>Status:</div>
            <div className='value'>{status}</div>
          </div>
          <div className='row'>
            <div className='name'>Progress:</div>
            <div className='value'>
              {status.includes('Connecting') && (
                <>
                  <div aria-busy='true' aria-describedby='loading-bar' />
                  <progress id='loading-bar' aria-label='Connecting' />
                </>
              )}
              {progressStatuses.includes(status) && (
                <progress
                  id='progress-bar'
                  value={chunks.length}
                  max={numberChunks || 1}
                />
              )}
              {status === 'Complete' && (
                <button onClick={() => window.close()}>Close</button>
              )}
              {status === 'Export Failed' && (
                <button onClick={() => nav(0)}>Retry</button>
              )}
              {errors && (
                <div className='errors'>
                  <span>{errors}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExportConsumer;
